import { observer } from "mobx-react";
import Chip, { CHIP_COLORS } from "../../../../../components/chip/chip";
import { PAYMENT_STATUS } from "../../rma-types";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    paymentStatus: PAYMENT_STATUS;
}
const PaymentStatusChip: React.FC<IProps> = observer(({ paymentStatus }) => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';

    const getColor = (paymentStatus: PAYMENT_STATUS) => {
        switch (paymentStatus) {
            case PAYMENT_STATUS.AUTHORIZED:
                return CHIP_COLORS.ORANGE;
            case PAYMENT_STATUS.CANCELED:
                return CHIP_COLORS.RED;
            case PAYMENT_STATUS.CHARGED:
                return CHIP_COLORS.GREEN;
        }
    }
    const getTranslationKey = (paymentStatus: PAYMENT_STATUS) => {
        switch (paymentStatus) {
            case PAYMENT_STATUS.AUTHORIZED:
                return 'PAYMENT_COLUMN_TITLE_FOR_AUTHORIZED';
            case PAYMENT_STATUS.CHARGED:
                return 'PAYMENT_COLUMN_TITLE_FOR_CAPTURED';
            case PAYMENT_STATUS.CANCELED:
                return 'CANCELED_STATUS';
        }
    }
    return (
        <Chip color={getColor(paymentStatus)} label={getTranslation(getTranslationKey(paymentStatus), pageScope)} />
    )
});

export default PaymentStatusChip;